import { useTranslation } from "react-i18next";
import { Modal, Box, IconButton, Divider, Typography, Button } from "@mui/material";

import { CloseButtonIcon } from "../../../assets/icons/credit-modal-icons";

const SubscriptionTermsModal = ({ open, closeModal }: { open: boolean; closeModal: () => void }) => {
  const { t } = useTranslation("plans", { keyPrefix: "component.termsAndConditionsModal" });
  return (
    <Modal open={open} onClose={closeModal}>
      <Box sx={styles.container}>
        <Box sx={styles.header}>
          <Typography variant="h5" sx={styles.title}>
            {t("termsAndConditions")}
          </Typography>
          <IconButton size="small" onClick={closeModal}>
            <CloseButtonIcon />
          </IconButton>
        </Box>
        <Divider flexItem orientation="horizontal" />
        <Box sx={styles.contentContainer} component="ol">
          <Typography variant="h6" sx={styles.subTitle}>
            {t("safetyFirst")}
          </Typography>
          <Typography sx={styles.contentListItem}>{t("weReviewAllService")}</Typography>
          <Typography component="li" sx={styles.contentListItem}>
            {t("youConfirm")}
          </Typography>
          <Typography component="li" sx={styles.contentListItem}>
            {t("allInformationProvided")}
          </Typography>
          <Typography component="li" sx={styles.contentListItem}>
            {t("youAgreeToDeliver")}
          </Typography>
          <Typography component="li" sx={styles.contentListItem}>
            {t("youAreResponsibleForEnsuring")}
          </Typography>
          <Typography component="li" sx={styles.contentListItem}>
            {t("youMustClearlyOutline")}
          </Typography>
          <Typography component="li" sx={styles.contentListItem}>
            {t("youAgreeToPay")}
          </Typography>
          <Typography component="li" sx={styles.contentListItem}>
            {t("goalngoReservesTheRight")}
          </Typography>{" "}
          <Typography component="li" sx={styles.contentListItem}>
            {t("youAreResponsibleForResponding")}
          </Typography>
          <Typography component="li" sx={styles.contentListItem}>
            {t("youAgreeToHandleCustomerInformation")}
          </Typography>
          <Typography component="li" sx={styles.contentListItem}>
            {t("youAgreeToUseGoalngoBranding")}
          </Typography>
          <Typography component="li" sx={styles.contentListItem}>
            {t("youAcceptThatCustomersMayLeaveReviews")}
          </Typography>
          <Button variant="primary-md" sx={styles.button} onClick={closeModal}>
            {t("iUnderstand")}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default SubscriptionTermsModal;

const styles = {
  container: {
    height: "fit-content",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    borderRadius: "var(--radius-xl, 12px)",
    background: "var(--Colors-Background-bg-primary, #FFF)",
    boxShadow:
      "0 20px 24px -4px var(--Colors-Effects-Shadows-shadow-xl_01, rgba(16, 24, 40, 0.08)), 0 8px 8px -4px var(--Colors-Effects-Shadows-shadow-xl_02, rgba(16, 24, 40, 0.03))",
    width: "640px",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "24px 24px 0 24px",
  },
  title: {
    color: "var(--colors-text-text-primary-900, #101828)",
    fontFamily: "Montserrat",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "28px",
  },
  subTitle: {
    color: "var(--Dark---1000, #111)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    padding: "0 24px 24px",
    margin: "0",
  },
  contentListItem: {
    listStyleType: "decimal",
    listStylePosition: "inside",
    fontFamily: "Montserrat",
    color: "var(--Dark---600, #707070)",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
  },
  button: {
    marginLeft: "auto",
  },
};
